export class IrisDeeplLanguage {
  readonly language: string; //DE
  readonly name: string; //German
  readonly translatedName?: string; //Allemand

  constructor(language: string, name: string, translatedName?: string) {
    this.language = language;
    this.name = name;
    this.translatedName = translatedName ?? name;
  }
}

export interface IrisDeeplPayloadI {
  targetLanguage: string;
  source: string;
  engine: string;
  format: string;
}

export interface IrisDeeplResultI {
  targetLanguage: string;
  detectedSourceLanguage: string;
  translatedText: string;
  id: number;
}
